import type { Transaction } from '@api/hooks/types/getTransactions';
import { Direction } from '@api/hooks/types/getTransactions';
import { DATE_FORMAT } from '@constants';
import { Chip, Typography } from '@gurupay/gp-ui-library';
import { TRANSACTION_STATUS_COLOR } from '@pages/batch-operations/utils';
import { formatNumberAmount } from '@utils/utils';
import clsx from 'clsx';
import { format } from 'date-fns';
import type { TFunction } from 'i18next';

export const getTransactionRenderers = (t: TFunction) => ({
	transactionInfo: ({
		beneficiary,
		amount,
		status,
		created_at,
		currency,
		direction,
	}: Transaction) => (
		<div className="flex items-center justify-between gap-space-8">
			<div className="w-0 min-w-0 flex-1 gap-space-8">
				<Typography className="font-bold" level="small-text">
					{beneficiary.name}
				</Typography>

				<div className="flex min-w-0 items-center gap-space-4 capitalize">
					<Chip
						color={TRANSACTION_STATUS_COLOR[status]}
						label={t(`recentTransactions.statuses.${status}`)}
						size="small"
						variant="filled"
					/>

					<Typography level="small-text">{format(created_at, DATE_FORMAT)}</Typography>
				</div>
			</div>

			<Typography
				className={clsx(
					'font-bold',
					direction === Direction.INWARD
						? 'text-brand-secondary-600'
						: 'text-neutral-950',
				)}
				level="small-text"
			>
				{direction === Direction.INWARD ? '+' : '-'}
				{formatNumberAmount(amount.toFixed(2))} {currency}
			</Typography>
		</div>
	),
});
